module.exports = __webpack_public_path__ + "img/coors-light-landing-gal-10.54ef1a47.jpg";